export const isPresent = (obj: any): boolean => {
  return obj !== undefined && obj !== null;
};
